import React from 'react';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { useTranslation } from 'react-i18next';

import type { UserProfileAddress } from '../../../types/user';

import { formatDutchPostalCode } from '../../../helpers/formatting';

import './style.scss';

export interface AddressTeaserProps {
  isDefault?: boolean;
  isDefaultBilling?: boolean;
  address: ImmutableEntity<UserProfileAddress>;
}

const AddressTeaser: React.FC<AddressTeaserProps> = ({
  isDefault = false,
  isDefaultBilling = false,
  address,
}) => {
  const { t } = useTranslation();
  const firstName = address.get('given_name');
  const lastName = address.get('family_name');
  const addressLine1 = address.get('address_line1');
  const addressLine2 = address.get('address_line2');
  const addressLine3 = address.get('address_line3');
  const locality = address.get('locality');
  const organization = address.get('organization');

  const postalCode = formatDutchPostalCode(address.get('postal_code'));

  return (
    <div className="AddressTeaser">
      {/*
        Default badges live in one wrapper so they can be laid out together —
        side by side in the overview, stacked top-right in the checkout
        selector. Billing is rendered first so it sits on top when stacked.
      */}
      {(isDefault || isDefaultBilling) && (
        <div className="AddressTeaser__badges">
          {isDefaultBilling && (
            <div className="AddressTeaser__default AddressTeaser__default--billing">
              {t('address.is_default_billing_address')}
            </div>
          )}
          {isDefault && (
            <div className="AddressTeaser__default">
              {t('address.is_default_address')}
            </div>
          )}
        </div>
      )}
      <div className="AddressTeaser__details">
        {organization && (
          <div className="AddressTeaser__line">{organization}</div>
        )}
        <div className="AddressTeaser__line1">
          {firstName} {lastName}
        </div>
        <div className="AddressTeaser__line2">
          {addressLine1} {addressLine2} {addressLine3}
        </div>
        <div className="AddressTeaser__line3">
          {postalCode} {locality}
        </div>
      </div>
    </div>
  );
};

export default AddressTeaser;
